'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';
import type { Equipment } from '@/lib/services/supabaseService';

interface EquipmentFilterProps {
  selectedType: string;
  onTypeSelect: (type: string) => void;
  equipment: Equipment[];
}

const EquipmentFilter: React.FC<EquipmentFilterProps> = ({
  selectedType,
  onTypeSelect,
  equipment,
}) => {
  const equipmentTypes = [
    { value: 'all', label: 'All Equipment', icon: 'SparklesIcon' },
    { value: 'washer', label: 'Washers', icon: 'CogIcon' },
    { value: 'dryer', label: 'Dryers', icon: 'FireIcon' },
    { value: 'iron', label: 'Irons', icon: 'BoltIcon' },
  ];

  const getEquipmentCount = (type: string) => {
    if (type === 'all') return equipment.length;
    return equipment.filter(e => e.equipmentType === type && e.status !== 'broken').length;
  };

  return (
    <div data-component-id="src/app/equipment-availability-calendar/components/EquipmentFilter.tsx:31:4" data-component-path="src/app/equipment-availability-calendar/components/EquipmentFilter.tsx" data-component-line="31" data-component-end-line="70" data-component-file="EquipmentFilter.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mb-6%22%7D" className="mb-6">
      <h3 data-component-id="src/app/equipment-availability-calendar/components/EquipmentFilter.tsx:32:6" data-component-path="src/app/equipment-availability-calendar/components/EquipmentFilter.tsx" data-component-line="32" data-component-end-line="32" data-component-file="EquipmentFilter.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-lg%20font-semibold%20font-headline%20text-foreground%20mb-4%22%2C%22textContent%22%3A%22Filter%20by%20Equipment%20Type%22%7D" className="text-lg font-semibold font-headline text-foreground mb-4">Filter by Equipment Type</h3>
      <div data-component-id="src/app/equipment-availability-calendar/components/EquipmentFilter.tsx:33:6" data-component-path="src/app/equipment-availability-calendar/components/EquipmentFilter.tsx" data-component-line="33" data-component-end-line="69" data-component-file="EquipmentFilter.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20md%3Agrid-cols-4%20gap-4%22%7D" className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {equipmentTypes.map((type) => {
          const count = getEquipmentCount(type.value);
          const isSelected = selectedType === type.value;

          return (
            <button data-component-id="src/app/equipment-availability-calendar/components/EquipmentFilter.tsx:39:12" data-component-path="src/app/equipment-availability-calendar/components/EquipmentFilter.tsx" data-component-line="39" data-component-end-line="66" data-component-file="EquipmentFilter.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
              key={type.value}
              onClick={() => onTypeSelect(type.value)}
              className={`p-4 rounded-lg border-2 transition-all duration-200 ${
                isSelected
                  ? 'bg-primary border-primary text-primary-foreground shadow-lg'
                  : 'bg-card border-border hover:border-primary hover:bg-primary/5'
              }`}
            >
              <div data-component-id="src/app/equipment-availability-calendar/components/EquipmentFilter.tsx:48:14" data-component-path="src/app/equipment-availability-calendar/components/EquipmentFilter.tsx" data-component-line="48" data-component-end-line="65" data-component-file="EquipmentFilter.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20items-center%20space-y-2%22%7D" className="flex flex-col items-center space-y-2">
                <Icon data-component-id="src/app/equipment-availability-calendar/components/EquipmentFilter.tsx:49:16" data-component-path="src/app/equipment-availability-calendar/components/EquipmentFilter.tsx" data-component-line="49" data-component-end-line="54" data-component-file="EquipmentFilter.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D"
                  name={type.icon as any}
                  size={32}
                  variant="outline"
                  className={isSelected ? 'text-primary-foreground' : 'text-primary'}
                />
                <span data-component-id="src/app/equipment-availability-calendar/components/EquipmentFilter.tsx:55:16" data-component-path="src/app/equipment-availability-calendar/components/EquipmentFilter.tsx" data-component-line="55" data-component-end-line="59" data-component-file="EquipmentFilter.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D" className={`font-semibold font-headline ${
                  isSelected ? 'text-primary-foreground' : 'text-foreground'
                }`}>
                  {type.label}
                </span>
                <span data-component-id="src/app/equipment-availability-calendar/components/EquipmentFilter.tsx:60:16" data-component-path="src/app/equipment-availability-calendar/components/EquipmentFilter.tsx" data-component-line="60" data-component-end-line="64" data-component-file="EquipmentFilter.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22available%22%7D" className={`text-sm font-body ${
                  isSelected ? 'text-primary-foreground/80' : 'text-muted-foreground'
                }`}>
                  {count} available
                </span>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default EquipmentFilter;